import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY            || "AIzaSyAwUTqtua2DNZ3Jpw7QQFPWGkAYLQmGLI8",
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN        || "eonik-ai.firebaseapp.com",
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID         || "eonik-ai",
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET     || "eonik-ai.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "472601880824",
  appId:             process.env.REACT_APP_FIREBASE_APP_ID             || "1:472601880824:web:c583f9abeab018cf74330d",
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
export const auth = getAuth(app);
